import { render, staticRenderFns } from "./BS5Overlay.vue?vue&type=template&id=2c96ad0f&scoped=true"
import script from "./BS5Overlay.vue?vue&type=script&lang=js"
export * from "./BS5Overlay.vue?vue&type=script&lang=js"
import style0 from "./BS5Overlay.vue?vue&type=style&index=0&id=2c96ad0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c96ad0f",
  null
  
)

export default component.exports